import moment from 'moment'

const sessionsToEventsFormatter = (sessions) => {
  return sessions.map(session => {
    const {
      _id,
      name,
      date,
      startTime,
      endTime
    } = session

    const dateStartTimeStr = `${date}T${startTime}`
    const startDateMomentObj = moment.utc(dateStartTimeStr);
    /*
     * This way of creating the date object ensures no timezone conversion so a time in California such as 10:20 AM
     * show up the exact same way in Georgia as 10:20 AM. If we want to convert to local time, we need to changes this code here
     */
    const startDateObj = new Date(
      startDateMomentObj.year(),
      startDateMomentObj.month(),
      startDateMomentObj.date(),
      startDateMomentObj.hour(),
      startDateMomentObj.minute(),
      startDateMomentObj.second(),
      startDateMomentObj.millisecond()
    );


    const dateEndTimeStr = `${date}T${endTime}`
    const endDateMomentObj = moment.utc(dateEndTimeStr);
    const endDateObj = new Date(
      endDateMomentObj.year(),
      endDateMomentObj.month(),
      endDateMomentObj.date(),
      endDateMomentObj.hour(),
      endDateMomentObj.minute(),
      endDateMomentObj.second(),
      endDateMomentObj.millisecond()
    );

    return {
      id: _id,
      title: name,
      start: startDateObj,
      end: endDateObj,
    }
  })
}

const eventsToSessionsFormatter = (sessions, events) => {
  return events.map(event => {
    const {
      id,
      start,
      end,
    } = event;

    let matchingSession;
    if (id.indexOf('new-') > -1) {
      matchingSession = sessions.find(({ id: _id }) => _id === id)
    } else {
      matchingSession = sessions.find(({ _id }) => _id === id)
    }

    if (matchingSession) {
      const updateSessionObj = { ...matchingSession }

      const startMoment = moment(start);
      const endMoment = moment(end);

      const dateStr = startMoment.format('YYYY-MM-DD')
      const startTimeStr = `${startMoment.format('HH:mm:ss')}.000Z`
      const endTimeStr = `${endMoment.format('HH:mm:ss')}.000Z`

      updateSessionObj.date = dateStr;
      updateSessionObj.startTime = startTimeStr;
      updateSessionObj.endTime = endTimeStr;

      return updateSessionObj
    } else {
      return undefined;
    }
  }).filter(Boolean)
}

const eventSessionFormatter = (session, event) => {
  const {
    start,
    end,
  } = event;

  const updateSessionObj = { ...session }

  const startMoment = moment(start);
  const endMoment = moment(end);

  const dateStr = startMoment.format('YYYY-MM-DD')
  const startTimeStr = `${startMoment.format('HH:mm:ss')}.000Z`
  const endTimeStr = `${endMoment.format('HH:mm:ss')}.000Z`

  updateSessionObj.date = dateStr;
  updateSessionObj.startTime = startTimeStr;
  updateSessionObj.endTime = endTimeStr;

  return updateSessionObj
}

/*
 * Starting point of sessions...not being used for now

const eventsToSessionsFormatter = (sessions, events) => {
  return sessions.map(session => {
    const {
      _id
    } = session;

    const updateSessionObj = { ...session }

    const matchingEvent = events.find(({ id }) => id === _id)

    if (matchingEvent) {
      const {
        start,
        end,
        // dirty
      } = matchingEvent;

      const startMoment = moment(start);
      const endMoment = moment(end);

      const dateStr = startMoment.format('YYYY-MM-DD')
      const startTimeStr = `${startMoment.format('hh:mm:ss')}.000Z`
      const endTimeStr = `${endMoment.format('hh:mm:ss')}.000Z`

      updateSessionObj.date = dateStr;
      updateSessionObj.startTime = startTimeStr;
      updateSessionObj.endTime = endTimeStr;

      // if (dirty) {
      //   updateSessionObj.dirty = true;
      // }
    }

    return updateSessionObj
  })
}
*/ 

/** Converts Prosolve events to react-big-calendar events */
const eventsToCalendarEventFormatter = (events) => {
  return events.map(event => {
    const {
      id,
      name,
      startDate,
      endDate,
      projectStatus,
    } = event

    const startDateMomentObj = moment(startDate);
    const endDateMomentObj = moment(endDate);

    return {
      id,
      title: name,
      start: startDateMomentObj.toDate(),
      end: endDateMomentObj.toDate(),
      projectStatus
    }
  })
}

export {
  sessionsToEventsFormatter,
  eventsToSessionsFormatter,
  eventSessionFormatter,
  eventsToCalendarEventFormatter
}